﻿import { projectSettings } from "../../config";

import LandingPage from "./LandingPage.svelte";
import PersonalDetails from "./PersonalDetails.svelte";
import ClaimDetails from "./ClaimDetails.svelte";
import Confirmation from "./Confirmation.svelte";
import Review from "./Review.svelte";
import ThankYou from "./ThankYou.svelte";

const title = projectSettings.classActionName;

const registrationPageList = [
    {
        pageIndex: 0,
        component: LandingPage,
        title: null,
        showInTracker: false,
        routeId: `${projectSettings.basePath}Registration`,
        nextPage: `${projectSettings.basePath}Registration/PersonalDetails`,
        properties: {
            pageTitle: `${title}`,
            lastVisitedPage: "Landing Page",
        },
    },
    {
        pageIndex: 1,
        component: PersonalDetails,
        title: "Personal Details",
        showInTracker: true,
        routeId: `${projectSettings.basePath}Registration/PersonalDetails`,
        nextPage: `${projectSettings.basePath}Registration/ClaimDetails`,
        previousPage: `${projectSettings.basePath}Registration`,
        properties: {
            pageTitle: `${title} - Personal Details`,
            persistUrl: `${projectSettings.basePath}api/project`,
            lastVisitedPage: "Personal Details",
        },
    },
    {
        pageIndex: 2,
        component: ClaimDetails,
        title: "Claim Details",
        showInTracker: true,
        routeId: `${projectSettings.basePath}Registration/ClaimDetails`,
        nextPage: `${projectSettings.basePath}Registration/Confirmation`,
        previousPage: `${projectSettings.basePath}Registration/PersonalDetails`,
        properties: {
            pageTitle: `${title} - Claim Details`,
            persistUrl: `${projectSettings.basePath}api/project`,
            lastVisitedPage: "Claim Details",
        },
    },
    {
        pageIndex: 7,
        component: Confirmation,
        title: "Confirmation",
        showInTracker: true,
        routeId: `${projectSettings.basePath}Registration/Confirmation`,
        previousPage: `${projectSettings.basePath}Registration/ClaimDetails`,
        nextPage: `${projectSettings.basePath}Registration/ThankYou`,
        properties: {
            pageTitle: `${title} - Confirmation`,
            nextPageLabel: "Submit",
            persistUrl: `${projectSettings.basePath}api/registration`,
            lastVisitedPage: "Confirmation",
        },
    },
    {
        pageIndex: 9,
        component: ThankYou,
        title: "Registration Submitted",
        showInTracker: false,
        routeId: `${projectSettings.basePath}Registration/ThankYou`,
        properties: {
            pageTitle: `${title} - Thank you`,
        },
    },
    {
        pageIndex: 10,
        component: Review,
        title: "Review",
        showInTracker: false,
        routeId: `${projectSettings.basePath}Review`,
        properties: {
            pageTitle: `${title} - Review`,
        },
    },
];


export default registrationPageList
